import { Component, OnDestroy, OnInit } from '@angular/core';
import { SessionActivityService } from './core/services/session-activity.service';
import { FeatureDisabledProblem } from './core/models/feature-flag.model';
import { FeatureFlagService } from './core/services/feature-flag.service';
import { Subscription } from 'rxjs';
import { ConfirmationService } from './core/services/confirmation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'tracker-ui';
  featureProblem: FeatureDisabledProblem | null = null;
  readonly confirmationRequest$;
  private featureErrorSubscription?: Subscription;

  constructor(
    private sessionActivityService: SessionActivityService,
    private featureFlags: FeatureFlagService,
    readonly confirmations: ConfirmationService
  ) {
    this.confirmationRequest$ = this.confirmations.request$;
  }

  ngOnInit(): void {
    this.sessionActivityService.start();
    this.featureErrorSubscription = this.featureFlags.featureError$.subscribe(problem => this.featureProblem = problem);
  }

  ngOnDestroy(): void {
    this.sessionActivityService.stop();
    this.featureErrorSubscription?.unsubscribe();
  }

  dismissFeatureError(): void {
    this.featureFlags.clearFeatureError();
  }
}
